import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, Transition as _Transition, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/themeThree/headerTextBg.png'


const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "groupName" }
const _hoisted_3 = { class: "gameCount" }
const _hoisted_4 = { class: "countText" }
const _hoisted_5 = { class: "game-slider-container" }
const _hoisted_6 = {
  key: 0,
  class: "game-slider-container"
}
const _hoisted_7 = {
  key: 1,
  class: "game-slider-container"
}
const _hoisted_8 = { class: "bottomText" }
const _hoisted_9 = { class: "showAllText" }

import { computed, inject, onMounted, ref } from 'vue'
import { PropType } from 'vue'
import GameCard from '../../game/components/gameCard.vue';
import { playClickSound } from '@/utils/media';
import { useRouter } from 'vue-router';
import { GameGroupData, GameList, goToPlayGame } from '@/view/home/supportScript';

export default /*@__PURE__*/_defineComponent({
  __name: 'gamePanel',
  props: {
    gameList: {
        type: Array as PropType<GameList[]>,
        required: true
    },
    groupImage: {
        type: String,
        default: ''
    },
    groupName: {
        type: String,
        default: ''
    },
    itemData: {
        type: Object as PropType<GameGroupData>,
        required: true
    },
    itemIndex: {
        type: Number,
    }

},
  emits: ['showGames'],
  setup(__props, { emit: __emit }) {

const slideDirection = ref<'left' | 'right'>('right')
const gameGrid = ref({
    rowCount: 0,
    columnCount: 0
})
const customStyles = ref({
    active_font_color: '',
    border_color: ""
})
const props = __props
const router = useRouter()
const gameCount = computed(() => props.gameList.length);
const displayCount = computed(() => props.gameList.length < 12 ? props.gameList.length : 12);
const isShowAllGame = ref(false)
const openRegisterLoginPopup = inject<(type: number) => void>('openRegisterLoginPopup')
const emits = __emit
const currentPage = ref(0)
const pageSize = computed(() => {
    return gameGrid.value.rowCount * gameGrid.value.columnCount
})

const totalPages = computed(() => {
    return Math.ceil(props.gameList.length / pageSize.value)
})

const paginatedGameList = computed(() => {
    const start = currentPage.value * pageSize.value
    return props.gameList.slice(start, start + pageSize.value)
})


const nextPage = () => {
    if (process.env.VUE_APP_PREVIEW_MODE == 'true') return
    if (currentPage.value < totalPages.value - 1) {
        playClickSound()
        slideDirection.value = 'right'
        currentPage.value++
    }
}

const prevPage = () => {
    if (process.env.VUE_APP_PREVIEW_MODE == 'true') return
    if (currentPage.value > 0) {
        playClickSound()
        slideDirection.value = 'left'
        currentPage.value--
    }
}
const GoToPlayGame = (id: any, makerId: any, favorite: number, favId: any) => {
    goToPlayGame(router, openRegisterLoginPopup, id, makerId, favorite, favId)
}
const showGames = () => {
    isShowAllGame.value = !isShowAllGame.value
}
onMounted(() => {
    gameGrid.value.rowCount = props.itemData.gamesGrid.rowCount
    gameGrid.value.columnCount = props.itemData.gamesGrid.columnCount
    customStyles.value.active_font_color = props.itemData.styles.active_font_color
    customStyles.value.border_color = props.itemData.styles.border_color
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_grid_item = _resolveComponent("van-grid-item")!
  const _component_van_grid = _resolveComponent("van-grid")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["panel_container", { pp_group: props.groupName === 'PP' }]),
    style: _normalizeStyle({ color: customStyles.value.active_font_color })
  }, [
    _cache[1] || (_cache[1] = _createElementVNode("img", {
      src: _imports_0,
      alt: "",
      width: "80%"
    }, null, -1)),
    _createVNode(_component_van_row, {
      class: "titleHead",
      justify: "space-between",
      style: {"margin-bottom":"10px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, {
          span: "15",
          class: "group_col"
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: props.groupImage,
              alt: ""
            }, null, 8, _hoisted_1),
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(__props.groupName)), 1),
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "slashLine" }, null, -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(gameCount.value), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('message.all')), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, {
          span: "8",
          class: "group_col_right"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "arrowBtn",
              onClick: prevPage
            }, [
              _createVNode(_component_van_icon, { name: "arrow-left" })
            ]),
            _createElementVNode("div", {
              class: "arrowBtn",
              onClick: nextPage
            }, [
              _createVNode(_component_van_icon, { name: "arrow" })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_5, [
      (!isShowAllGame.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_Transition, {
              name: slideDirection.value === 'right' ? 'slide-right' : 'slide-left'
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock("div", {
                  class: "page-block",
                  key: currentPage.value
                }, [
                  _createVNode(_component_van_grid, {
                    "column-num": gameGrid.value.columnCount,
                    border: false
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedGameList.value, (item) => {
                        return (_openBlock(), _createBlock(_component_van_grid_item, {
                          key: item.id,
                          class: "grid-item"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(GameCard, {
                              gameImage: item.customIcon,
                              gameTypeId: item.id,
                              gameIsFavorite: item.isFavorite,
                              onClickGameCard: ($event: any) => (GoToPlayGame(item.activeGameId, item.gameMakerId, item.isFavorite, item.id))
                            }, null, 8, ["gameImage", "gameTypeId", "gameIsFavorite", "onClickGameCard"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["column-num"])
                ]))
              ]),
              _: 1
            }, 8, ["name"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(), _createElementBlock("div", {
              class: "page-block",
              key: currentPage.value
            }, [
              _createVNode(_component_van_grid, {
                "column-num": gameGrid.value.columnCount,
                border: false
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.gameList, (item) => {
                    return (_openBlock(), _createBlock(_component_van_grid_item, {
                      key: item.id,
                      class: "grid-item"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(GameCard, {
                          gameImage: item.customIcon,
                          gameTypeId: item.id,
                          gameIsFavorite: item.isFavorite,
                          onClickGameCard: ($event: any) => (GoToPlayGame(item.activeGameId, item.gameMakerId, item.isFavorite, item.id))
                        }, null, 8, ["gameImage", "gameTypeId", "gameIsFavorite", "onClickGameCard"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["column-num"])
            ]))
          ])),
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('game.moreGameText', {
                displayCount: (isShowAllGame.value ? gameCount.value : displayCount.value),
                gameCount: gameCount.value })), 1),
      _createElementVNode("div", _hoisted_9, [
        (!isShowAllGame.value && gameCount.value > 12)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: showGames
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t('game.showAll')), 1),
              _createVNode(_component_van_icon, {
                name: "arrow-down",
                class: "showIcon"
              })
            ]))
          : _createCommentVNode("", true),
        (isShowAllGame.value && gameCount.value > 12)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              onClick: showGames
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t('game.collect')), 1),
              _createVNode(_component_van_icon, {
                name: "arrow-up",
                class: "showIcon"
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 6))
}
}

})